import React, { useState } from 'react'

import CloseDialogIconButton from 'src/components/iconbutton/CloseDialogIconButton.js'
import NmotTranslationText from 'src/views/nmot/shared/NmotTranslationText'
import AllRowsDialogContext from './AllRowsDialogContext.js'
import AllRowsDialogForm from './AllRowsDialogForm.js'
import Paper from '@material-ui/core/Paper'
import { components } from 'cng-web-lib'

const { CngDialog } = components

function AllRowsDialog({
  isDialogOpen,
  closeDialog,
  showNotification,
  cngTableRef
}) {
  const translatedTextsObject = NmotTranslationText()
  const [isDeleting, setDeleting] = useState(false)
  const [isArchiving, setArchiving] = useState(false)
  const [isDownloading, setDownloading] = useState(false)

  return (
    <AllRowsDialogContext.Provider
      value={{
        closeDialog,
        showNotification,
        form: {
          isDeleting,
          setDeleting,
          isArchiving,
          setArchiving,
          isDownloading,
          setDownloading
        },
        cngTableRef
      }}
    >
      <CngDialog
        customDialogContent={
          <Paper>
            <div style={{ overflow: 'hidden' }}>
              <AllRowsDialogForm />
            </div>
          </Paper>
        }
        dialogTitle={
          <>
            {translatedTextsObject.confirm}
            <CloseDialogIconButton
              onClick={closeDialog}
              disabled={isDeleting || isArchiving || isDownloading}
            />
          </>
        }
        open={isDialogOpen}
        fullWidth
        maxWidth='sm'
      />
    </AllRowsDialogContext.Provider>
  )
}

export default AllRowsDialog
